<template>
      <div>
          <div
            class="col-sm-4 sd-side-menu sd-map__container"
            :class="[{'sd-bg--white': subsectionId}, {'sd-bg--gray': !subsectionId}]"
            >
            <component
              :is="selectComponent(subsectionId)"
              :subsectionId="subsectionId"
              @changeSubsectionId="subsectionId = $event" ></component>
          </div>
          <div class="container-fluid w-100 p-0 ">
            <div class="row w-100">
              <div class="col-md-8 offset-4 p-0">
                <Map> </Map>
              </div>
            </div>
          </div>
      </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Map from '@/views/Dashboard/map.vue';
import Projects from '@/components/projects.vue';
import SubSection from '@/components/subsection.vue';

export default {
  data() {
    return {
      subsectionId: false,
    };
  },
  components: {
    Map,
    Projects,
    SubSection,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
  },
  created() {
     document.title="Skylark Drones Inspection Portal";
    this.triggerProjectsFetch();
    // TODO: Handle false case
  },
  methods: {
    ...mapActions([
      'retrieveProjects',
    ]),
    triggerProjectsFetch() {
      this.retrieveProjects();
    },
    selectComponent(subSectionId) {
      if (subSectionId) {
        return SubSection;
      }

      return Projects;
    },
  },

};
</script>

<style lang="scss">
@import '@/assets/sass/_variables.scss';

.sd-map__container{
  z-index: 10001;
}

.sd-side-menu {
  position: fixed !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-bottom: 15px;
  overflow-y: scroll !important;
  // max-height: 100% !important;
  // border: 1px solid red;
  background-color: $gray-light;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: $gray-light;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $gray;
    border-radius: 0.2rem;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $gray-dark;
  }
}

</style>

